import React, { FC } from 'react';
import classNames from 'classnames';

export const ItemMover = ({ onMove, onMouseUp, classes, children }) => {
    const handleMouseMove = (event) => {
        onMove(event.movementX);
    };
    const handleMouseUp = (event) => {
        onMouseUp();
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
    };

    return (
        <div
            className={classNames([classes])}
            onMouseDown={(e) => {
                e.stopPropagation();
                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
            }}
        >
            {children}
        </div>
    );
};
